import CityPageTemplate from "../city-template/CityPageTemplate";
import { shelbyvilleConfig } from "./data";

export default function ShelbyvillePage() {
  return <CityPageTemplate config={shelbyvilleConfig} />;
}